export { default as PaintingService } from './painting';
export { default as EmailService } from './email';
